export enum Scope {
    HomePage = 'homepage',
    Footer = 'footer',
    ProductDetailPage = 'pdp',
    ProductListingPage = 'plp',
}
